import React from 'react';
import { StyledWrapper, StyledContent, StyledHeader } from './cabin-module.style';
import { DreamlinesButton } from '../../../atoms/dreamlines-button/dreamlines-button';
import { theme } from '../../../../style/global-style';
import { eventTracker } from '../../../../utils/EventTracker';

interface IProps {
    heading: string;
    description: string;
    buttonText: string;
    redirectUrl: string | null;
    shipName: string;
}

export const CabinModule = ({
    heading,
    description,
    buttonText,
    redirectUrl,
    shipName,
}: IProps) => {
    return (
        <StyledWrapper>
            <StyledHeader>{heading}</StyledHeader>
            <StyledContent>{description}</StyledContent>
            {redirectUrl && (
                <DreamlinesButton
                    tertiary
                    redirectUrl={redirectUrl}
                    wrapperStyle={{
                        marginBottom: '16px',
                    }}
                    style={{
                        borderColor: theme.shades.white,
                        color: theme.shades.white,
                    }}
                    onClick={() => {
                        eventTracker.track({
                            event: 'click',
                            category: 'link-to-subpage',
                            action: 'cabin-and-deck-module',
                            label: `ship-${shipName}`,
                        });
                    }}
                >
                    {buttonText}
                </DreamlinesButton>
            )}
        </StyledWrapper>
    );
};
